import React from 'react'
import {
    Container,
    Text,
    TextTag,
    TokenTextAppearance,
    Breakpoints,
    CTA,
} from '@volkswagen-onehub/components-core'
import {SizeEnum} from '@volkswagen-onehub/tokens'
import styled from 'styled-components'
import {useTranslation} from 'react-i18next'

const FaqContainer = styled.div`
    border-top: ${({theme}) => theme.size.border.active} solid
        ${({theme}) => theme.colors.border.divider};
    margin-top: ${(props) => props.theme.size.static650};
    padding-top: ${(props) => props.theme.size.static800};
    padding-bottom: ${(props) => props.theme.size.dynamic0300};

    @media (min-width: ${Breakpoints.b960}px) {
        padding-right: ${(props) => props.theme.size.grid001};
        padding-left: ${(props) => props.theme.size.grid001};
    }

    @media (min-width: ${Breakpoints.b960}px) {
        padding-right: ${(props) => props.theme.size.grid003};
        padding-left: ${(props) => props.theme.size.grid003};
    }

    @media (min-width: ${Breakpoints.b1280}px) {
        padding-right: ${(props) => props.theme.size.grid002};
        padding-left: ${(props) => props.theme.size.grid002};
    }
`

export function Faq(): React.JSX.Element {
    const {t} = useTranslation('fa-flotte')

    return (
        <FaqContainer>
            <Text tag={TextTag.h2} appearance={TokenTextAppearance.headline300}>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t('faq.title'),
                    }}
                />
            </Text>

            <Container
                padding={{
                    top: {
                        [Breakpoints.default]: SizeEnum.static370,
                    },
                    left: {
                        [Breakpoints.b560]: SizeEnum.grid001,
                    },
                }}
                gutter={SizeEnum.static370}
                wrap="always"
            >
                <Text tag={TextTag.p} appearance={TokenTextAppearance.copy200}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: t('faq.text'),
                        }}
                    />
                </Text>

                <CTA
                    tag="a"
                    emphasis="tertiary"
                    href={t('faq.link')}
                    aria-label={t('cta.faq')}
                >
                    {t('cta.faq')}
                </CTA>
            </Container>
        </FaqContainer>
    )
}
